import { render } from "./ContactInfo.vue?vue&type=template&id=bfb40f9c&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"

import "./ContactInfo.vue?vue&type=style&index=0&id=bfb40f9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfb40f9c"]])

export default __exports__